module.exports = __webpack_public_path__ + "img/staunty.45953408.png";